module.exports = __webpack_public_path__ + "img/GoogleAnalytics.d5dbfb36.svg";